module.exports = __webpack_public_path__ + "Huawei_p20_icon.svg?13df9a644b8c91495aa6398530084ec9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Huawei_p20_icon.svg
// module id = 196
// module chunks = 0